module.exports = __webpack_public_path__ + "img/home_stretches_video2.24bd9268.png";